/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { FaVideo, FaVideoSlash } from "react-icons/fa";
import { FiMicOff, FiMic } from "react-icons/fi";
import { IoCall } from "react-icons/io5";
import { MyContext } from "../../Context/MyProvider";

import {
    LocalUser,
    RemoteUser,
    useIsConnected,
    useJoin,
    useLocalMicrophoneTrack,
    useLocalCameraTrack,
    usePublish,
    useRemoteUsers,
} from "agora-rtc-react";
import { socket } from "../../socket";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

const VideoCall = ({ Data }) => {

    const { t } = useTranslation();

    const { ImgBaseUrl, agoraAppId, setShowCall } = useContext(MyContext);

    const [calling, setCalling] = useState(false);
    const [channel, setChannel] = useState("");
    const [token, setToken] = useState(null);
    const [myProPic, setMyProPic] = useState("https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg");
    const [micOn, setMic] = useState(false);
    const [cameraOn, setCamera] = useState(false);

    const isConnected = useIsConnected();
    const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
    const { localCameraTrack } = useLocalCameraTrack(cameraOn);
    const remoteUsers = useRemoteUsers();

    useJoin({ appid: agoraAppId, channel, token }, calling);
    usePublish(calling ? [localMicrophoneTrack, localCameraTrack] : []);

    useEffect(() => {
        if (remoteUsers.length === 0) {
            if (calling) {
                setShowCall(false);
                setMic(false);
                setCamera(false);
            }
            setCalling(false);
        }
    }, [remoteUsers, setCalling]);

    const HandleCallAnswer = () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setMic(true);
            setCamera(true);
            setCalling(true);
            setChannel(`${Userid}_${Data?.doctor_id}`);
            setToken(null);
        }
    }

    const LeaveCall = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            const SocketData = {
                id: Userid,
                uid: Data.doctor_id
            }

            socket.emit("Audio_video_call_Cut", SocketData);
        }

        if (calling) {
            setCalling(a => !a);
        }
        setShowCall(false);
    }

    useEffect(() => {
        const Userid = secureLocalStorage.getItem("Userid");

        const handleNewChat = (msg) => {
            // console.log("Other_user_Call_Cut", msg);
            LeaveCall();
        }

        socket.on(`Other_user_Call_Cut ${Userid}`, handleNewChat);

        return () => {
            socket.off(`Other_user_Call_Cut ${Userid}`, handleNewChat);
        };

    }, []);


    return (
        <div
            className="flex items-end Callimg justify-center room h-[100%]">
            {isConnected ? (
                <div className="user-list">
                    {remoteUsers.length > 0 && (
                        <div className="user You">
                            <LocalUser
                                audioTrack={localMicrophoneTrack}
                                cameraOn={cameraOn}
                                micOn={micOn}
                                videoTrack={localCameraTrack}
                                cover={myProPic}
                            />
                        </div>
                    )}
                    {remoteUsers.length > 0 && (
                        remoteUsers.map((user) => (
                            <div className="user remote" key={user.uid}>
                                <RemoteUser cover={ImgBaseUrl + Data?.logo} user={user} />
                            </div>
                        ))
                    )}
                </div>
            )
                : (<div style={{ backgroundImage: `url(${ImgBaseUrl + Data?.logo})` }} className="bg_img">
                    <div className="h-[100%] flex items-end justify-center z-[888] relative px-[10px] py-[20px]">
                        <div className="text-center">
                            <h1 className='text-white font-[500] text-[18px]'>{Data?.name}</h1>
                            <span className='text-white text-[16px]'>({t("In Coming Video Call From")}) {Data?.name}</span>
                            <div className="mt-[25px] flex items-center justify-center gap-[50px]">
                                <button onClick={LeaveCall} className="bg-red-500 p-[10px] rounded-[50px]">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                        <g id=" 24px / Call Missed">
                                            <g id="Call Missed">
                                                <path id="Stroke 1" d="M21.3283 2.75L15.3283 8.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path id="Stroke 3" d="M15.3283 2.75L21.3283 8.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                <path id="Stroke 5" fillRule="evenodd" clipRule="evenodd" d="M7.70098 16.299C0.802193 9.40023 1.78303 6.24116 2.51123 5.22211C2.60358 5.05863 4.90601 1.61189 7.3751 3.63408C13.5011 8.67946 5.74461 7.96612 10.8898 13.1113C16.0339 18.2554 15.3205 10.5 20.3659 16.6249C22.3881 19.094 18.9414 21.3954 18.7779 21.4888C17.7588 22.217 14.5998 23.1978 7.70098 16.299Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                                <button onClick={HandleCallAnswer} className="bg-green-500 p-[10px] rounded-[50px]">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id=" 24px / Call">
                                            <g id="Call">
                                                <path id="Stroke 1" fillRule="evenodd" clipRule="evenodd" d="M8.20049 15.799C1.3025 8.90022 2.28338 5.74115 3.01055 4.72316C3.10396 4.55862 5.40647 1.11188 7.87459 3.13407C14.0008 8.17945 6.2451 7.46611 11.3894 12.6113C16.5348 17.7554 15.8214 9.99995 20.8659 16.1249C22.8882 18.594 19.4413 20.8964 19.2778 20.9888C18.2598 21.717 15.0995 22.6978 8.20049 15.799Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>)}

            {isConnected && (
                <div className="flex justify-center z-[999] relative gap-[15px] py-[20px]">
                    {remoteUsers.length > 0 && (
                        <>
                            <button className="btn" onClick={() => setMic(a => !a)}>
                                {micOn ? (
                                    <FiMic className="bg-slate-600 text-white rounded-full p-[10px] w-[40px] h-[40px]" />
                                ) : (
                                    <FiMicOff className="bg-slate-600 text-white rounded-full p-[10px] w-[40px] h-[40px]" />
                                )}
                            </button>
                            <button className="btn" onClick={() => setCamera(a => !a)}>
                                {cameraOn ? (
                                    <FaVideo className="bg-blue-600 text-white rounded-full p-[10px] w-[40px] h-[40px]" />
                                ) : (
                                    <FaVideoSlash className="bg-blue-600 text-white rounded-full p-[10px] w-[40px] h-[40px]" />
                                )}
                            </button>
                        </>
                    )}
                    <button
                        className={`btn btn-phone ${calling ? "btn-phone-active" : ""}`}
                        onClick={LeaveCall}
                    >
                        <IoCall className="bg-red-500 text-white w-[40px] h-[40px] p-[10px] rounded-full" />
                    </button>
                </div>
            )}
        </div>
    );
};


export default VideoCall;

/* jshint ignore:end */
